import React from 'react';
import { Check, X, Clock, Heart, Brain, Zap, ChevronRight, Star, Utensils, Sparkles, Quote } from 'lucide-react';
export function LandingPage() {
  const scrollToCTA = () => {
    const element = document.getElementById('cta-section');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handlePurchaseClick = () => {
    window.location.href = 'https://pay.hotmart.com/N103919113H?off=i97a4g3n&checkoutMode=10';
  };
  return <div className="min-h-screen font-sans text-[#4A3728] bg-[#FFF8DC]" data-id="element-2">
      {/* Winter Sale Banner */}
      <div className="bg-[#D2691E] text-white py-2 px-4 text-center font-bold text-sm md:text-base sticky top-0 z-50 shadow-md" data-id="element-3">
        <div className="flex items-center justify-center gap-2" data-id="element-4">
          <Sparkles className="w-4 h-4" data-id="element-5" />
          <span data-id="element-6">Soldes d'Hiver 2026: -50% de réduction</span>
          <Sparkles className="w-4 h-4" data-id="element-7" />
        </div>
      </div>

      {/* Hero Section */}
      <header className="relative overflow-hidden bg-gradient-to-b from-[#FAEBD7] to-[#FFF8DC] pt-8 pb-12 lg:pt-16 lg:pb-20" data-id="element-8">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-9">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16" data-id="element-10">
            <div className="lg:w-1/2 text-center lg:text-left space-y-4 lg:space-y-6" data-id="element-11">
              <div className="inline-block px-3 py-1.5 bg-[#FF8C42]/10 rounded-full text-[#D2691E] font-semibold tracking-wide text-xs md:text-sm" data-id="element-12">
                STOP À LA CHARGE MENTALE
              </div>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-[#2C1810]" data-id="element-13">
                Il est 18h12.
                <br data-id="element-14" />
                Les enfants ont faim.
                <br data-id="element-15" />
                <span className="text-[#D2691E]" data-id="element-16">Ton téléphone vibre.</span>
              </h1>
              <p className="text-lg md:text-xl text-[#5D4037] leading-snug" data-id="element-17">
                Et cette question revient. Encore. Toujours.
                <br data-id="element-18" />
                <span className="font-bold italic" data-id="element-19">
                  "Qu'est-ce qu'on mange ce soir ?"
                </span>
              </p>
              <div className="pt-2" data-id="element-20">
                <button onClick={scrollToCTA} className="bg-[#FF8C42] hover:bg-[#E67A35] text-white text-base md:text-lg font-bold py-3 px-6 md:py-4 md:px-8 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 mx-auto lg:mx-0 w-full sm:w-auto" data-id="element-21">
                  Découvre AirFryer Facile
                  <ChevronRight className="w-5 h-5" data-id="element-22" />
                </button>
              </div>
            </div>
            <div className="lg:w-1/2 relative" data-id="element-23">
              <div className="absolute inset-0 bg-[#FF8C42] rounded-full filter blur-3xl opacity-20 transform scale-110" data-id="element-24"></div>
              <img src="https://cdn.magicpatterns.com/uploads/dXHBWdcRn6HS7W6VbeCoMs/portada.jpg" alt="Livre AirFryer Facile" className="relative rounded-2xl shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500 max-w-sm mx-auto lg:max-w-md border-4 border-white" data-id="element-25" />
            </div>
          </div>
        </div>
      </header>

      {/* Problem Section */}
      <section className="py-10 md:py-16 bg-white" data-id="element-26">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-12" data-id="element-28">
            <div className="lg:w-1/2 space-y-4 lg:space-y-6" data-id="element-29">
              <h2 className="text-2xl md:text-3xl font-bold text-[#2C1810] leading-tight" data-id="element-30">
                Le dîner n'est pas un problème de cuisine.
                <br data-id="element-31" />
                <span className="text-[#D2691E]" data-id="element-32">
                  C'est un problème de charge mentale.
                </span>
              </h2>
              <p className="text-base md:text-lg text-[#5D4037]" data-id="element-33">
                Chaque soir, c'est la même chose :
              </p>
              <ul className="space-y-2" data-id="element-34">
                {['Penser', 'Choisir', 'Anticiper', 'Adapter', 'Faire plaisir', 'Aller vite', 'Manger sain'].map(item => <li key={item} className="flex items-center gap-2 text-base md:text-lg text-[#5D4037]" data-id="element-35">
                    <div className="w-2 h-2 rounded-full bg-[#D2691E]" data-id="element-36"></div>
                    {item}
                  </li>)}
              </ul>
              <div className="bg-[#FAEBD7] p-4 md:p-5 rounded-xl border-l-4 border-[#D2691E]" data-id="element-37">
                <p className="text-[#8B4513] italic font-medium text-sm md:text-base leading-snug" data-id="element-38">
                  "Tout ça… quand tu n'as plus aucune énergie mentale. Et au
                  final ? Des pâtes. Encore. Ou le delivery. Avec cette petite
                  voix : 'Je pourrais mieux faire…'"
                </p>
              </div>
            </div>
            <div className="lg:w-1/2" data-id="element-39">
              <img src="https://cdn.magicpatterns.com/uploads/aSsM9GnbZvZB36Jr782Y5P/2.png" alt="Sandwichs appétissants" className="rounded-2xl shadow-xl object-cover h-[350px] md:h-[450px] w-full" data-id="element-40" />
            </div>
          </div>
        </div>
      </section>

      {/* Reality Check */}
      <section className="py-12 md:py-16 bg-[#2C1810] text-[#FAEBD7]" data-id="element-41">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center max-w-4xl" data-id="element-42">
          <Utensils className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-4 text-[#FF8C42]" data-id="element-43" />
          <h2 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6" data-id="element-44">
            Et pourtant… Tu as une AirFryer.
          </h2>
          <p className="text-lg md:text-xl leading-snug mb-8 opacity-90" data-id="element-45">
            Un appareil censé te simplifier la vie. Rapide. Pratique. Sain.
            <br data-id="element-46" />
            Mais soyons honnêtes :{' '}
            <span className="text-[#FF8C42] font-bold" data-id="element-47">
              Elle prend la poussière plus qu'elle ne t'aide.
            </span>
          </p>
          <div className="bg-[#3E2723] p-6 md:p-7 rounded-2xl shadow-lg border border-[#5D4037]" data-id="element-48">
            <h3 className="text-xl md:text-2xl font-bold mb-3 text-white" data-id="element-49">
              Le vrai blocage n'est PAS la cuisine
            </h3>
            <p className="text-base md:text-lg text-[#D7CCC8] leading-snug" data-id="element-50">
              Le vrai blocage, c'est décider quoi cuisiner quand tu es déjà
              épuisée. Pas besoin de motivation. Pas besoin de discipline.
              <br data-id="element-51" />
              <br data-id="element-52" />
              <span className="text-[#FF8C42] font-bold text-lg md:text-xl" data-id="element-53">
                Tu as besoin d'un cerveau externe.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* Solution Reveal */}
      <section className="py-12 md:py-16 bg-[#FFF8DC] overflow-hidden" data-id="element-54">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
          <div className="text-center mb-10 md:mb-12" data-id="element-56">
            <span className="text-[#D2691E] font-bold tracking-wider uppercase text-xs md:text-sm" data-id="element-57">
              La solution existe
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] mt-2 mb-3 md:mb-4" data-id="element-58">
              🎉 Voici AirFryer Facile
            </h2>
            <p className="text-lg md:text-xl text-[#5D4037] max-w-3xl mx-auto leading-snug" data-id="element-59">
              300 recettes rapides, saines et sans effort, conçues pour les
              soirs de fatigue réelle.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8 items-center mb-10 md:mb-12" data-id="element-60">
            <div className="bg-white p-6 md:p-7 rounded-2xl shadow-lg space-y-4 border-t-4 border-[#FF8C42]" data-id="element-61">
              <h3 className="text-xl md:text-2xl font-bold text-[#2C1810]" data-id="element-62">
                Ce n'est PAS :
              </h3>
              <ul className="space-y-3" data-id="element-63">
                {['Un livre à lire', 'Un manuel technique', 'Un projet culinaire ambitieux'].map(item => <li key={item} className="flex items-center gap-2 text-base md:text-lg text-[#5D4037]" data-id="element-64">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0" data-id="element-65" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white p-6 md:p-7 rounded-2xl shadow-lg space-y-4 border-t-4 border-[#4CAF50]" data-id="element-66">
              <h3 className="text-xl md:text-2xl font-bold text-[#2C1810]" data-id="element-67">
                C'est :
              </h3>
              <ul className="space-y-3" data-id="element-68">
                {['Un outil de survie quotidienne', 'Un système anti-décision', 'Un plan B permanent pour le dîner'].map(item => <li key={item} className="flex items-center gap-2 text-base md:text-lg text-[#5D4037]" data-id="element-69">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-70" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Imagine Scenario */}
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-71">
            <div className="flex flex-col md:flex-row" data-id="element-72">
              <div className="md:w-1/2" data-id="element-73">
                <img src="https://cdn.magicpatterns.com/uploads/nqwcvb6HfcAQkEas2i1UDi/2.jpg" alt="Poulet rôti AirFryer" className="h-full w-full object-cover min-h-[250px]" data-id="element-74" />
              </div>
              <div className="md:w-1/2 p-6 md:p-10 flex flex-col justify-center bg-[#FAEBD7]" data-id="element-75">
                <h3 className="text-2xl md:text-3xl font-bold text-[#2C1810] mb-4" data-id="element-76">
                  Imagine plutôt ça…
                </h3>
                <div className="space-y-3 md:space-y-4 text-base md:text-lg text-[#5D4037]" data-id="element-77">
                  <p data-id="element-78">
                    Il est 18h. Tu ouvres un guide.{' '}
                    <span className="font-bold text-[#D2691E]" data-id="element-79">
                      Tu choisis une recette en 30 secondes.
                    </span>
                  </p>
                  <p data-id="element-80">
                    Tu mets les ingrédients dans l'AirFryer. Tu appuies sur un
                    bouton.
                  </p>
                  <p data-id="element-81">20 à 30 minutes plus tard :</p>
                  <ul className="space-y-1.5 font-medium" data-id="element-82">
                    <li className="flex items-center gap-2" data-id="element-83">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-[#D2691E]" data-id="element-84" />{' '}
                      Dîner prêt
                    </li>
                    <li className="flex items-center gap-2" data-id="element-85">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-[#D2691E]" data-id="element-86" />{' '}
                      Peu de vaisselle
                    </li>
                    <li className="flex items-center gap-2" data-id="element-87">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-[#D2691E]" data-id="element-88" />{' '}
                      Des enfants contents
                    </li>
                    <li className="flex items-center gap-2" data-id="element-89">
                      <Check className="w-4 h-4 md:w-5 md:h-5 text-[#D2691E]" data-id="element-90" />{' '}
                      Et toi… enfin détendue
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-12 md:py-16 bg-white" data-id="element-91">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#2C1810] mb-8 md:mb-10" data-id="element-93">
            Concrètement, AirFryer Facile c'est :
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-94">
            {[{
            icon: Utensils,
            title: '300 dîners résolus',
            desc: 'Pour les 10 prochains mois'
          }, {
            icon: Clock,
            title: 'Rapide',
            desc: 'Recettes prêtes en 20–30 minutes'
          }, {
            icon: Star,
            title: 'Simple',
            desc: 'Ingrédients simples du quotidien'
          }, {
            icon: Zap,
            title: 'Accessible',
            desc: 'AirFryer basique (pas besoin de modèle premium)'
          }, {
            icon: Brain,
            title: 'Zéro charge mentale',
            desc: 'Zéro blabla, zéro stress'
          }, {
            icon: Heart,
            title: 'Sain & Bon',
            desc: 'Sans culpabilité, avec plaisir'
          }].map((benefit, idx) => <div key={idx} className="bg-[#FFF8DC] p-5 md:p-6 rounded-xl border border-[#FAEBD7]" data-id="element-95">
                <benefit.icon className="w-8 h-8 md:w-9 md:h-9 text-[#D2691E] mb-3" data-id="element-96" />
                <h3 className="text-lg md:text-xl font-bold text-[#2C1810] mb-1.5" data-id="element-97">
                  {benefit.title}
                </h3>
                <p className="text-sm md:text-base text-[#5D4037]" data-id="element-98">
                  {benefit.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Comparison / Why Others Failed */}
      <section className="py-12 md:py-16 bg-[#FAEBD7]" data-id="element-99">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12" data-id="element-101">
            <div className="lg:w-1/2" data-id="element-102">
              <img src="https://cdn.magicpatterns.com/uploads/x9FzjMy7V1yjQFtQG3Xcpv/3.jpg" alt="Plat sain et coloré" className="rounded-2xl shadow-xl object-cover h-[350px] md:h-[500px] w-full" data-id="element-103" />
            </div>
            <div className="lg:w-1/2 space-y-5 md:space-y-6" data-id="element-104">
              <h2 className="text-2xl md:text-3xl font-bold text-[#2C1810]" data-id="element-105">
                Pourquoi les autres solutions t'ont laissée tomber
              </h2>
              <div className="space-y-4" data-id="element-106">
                {[{
                title: 'Les recettes gratuites ?',
                desc: 'Trop de choix = trop de fatigue'
              }, {
                title: 'Les livres de cuisine ?',
                desc: 'Irréalistes pour un mardi soir'
              }, {
                title: 'Le batch cooking ?',
                desc: 'Bonne idée… quand on a du temps'
              }, {
                title: 'Les apps ?',
                desc: 'Encore une chose à gérer'
              }].map((item, idx) => <div key={idx} className="flex gap-3" data-id="element-107">
                    <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-white flex items-center justify-center flex-shrink-0 shadow-sm text-[#D2691E] font-bold text-lg" data-id="element-108">
                      ?
                    </div>
                    <div data-id="element-109">
                      <h4 className="text-lg md:text-xl font-bold text-[#2C1810]" data-id="element-110">
                        {item.title}
                      </h4>
                      <p className="text-sm md:text-base text-[#5D4037]" data-id="element-111">
                        {item.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
              <div className="mt-6 p-4 md:p-5 bg-white rounded-xl border border-[#D2691E]/20" data-id="element-112">
                <p className="text-base md:text-lg font-medium text-[#2C1810]" data-id="element-113">
                  👉 Le problème n'était jamais toi.
                  <br data-id="element-114" />
                  👉 C'était la charge mentale.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Transformation / Emotional Outcome */}
      <section className="py-12 md:py-16 bg-[#2C1810] text-[#FAEBD7] relative overflow-hidden" data-id="element-115">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-116"></div>
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-117">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 md:mb-10" data-id="element-118">
            Ce que ça change vraiment…
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto mb-10 md:mb-12" data-id="element-119">
            <div className="p-5 md:p-6 border border-[#5D4037] rounded-xl bg-[#3E2723]/50 backdrop-blur-sm" data-id="element-120">
              <h3 className="text-lg md:text-xl font-bold text-[#FF8C42] mb-1.5" data-id="element-121">
                Moins de stress
              </h3>
              <p className="text-sm md:text-base" data-id="element-122">
                Des soirées plus calmes et sereines
              </p>
            </div>
            <div className="p-5 md:p-6 border border-[#5D4037] rounded-xl bg-[#3E2723]/50 backdrop-blur-sm" data-id="element-123">
              <h3 className="text-lg md:text-xl font-bold text-[#FF8C42] mb-1.5" data-id="element-124">
                Plus de variété
              </h3>
              <p className="text-sm md:text-base" data-id="element-125">
                Des repas sains sans y penser
              </p>
            </div>
            <div className="p-5 md:p-6 border border-[#5D4037] rounded-xl bg-[#3E2723]/50 backdrop-blur-sm" data-id="element-126">
              <h3 className="text-lg md:text-xl font-bold text-[#FF8C42] mb-1.5" data-id="element-127">
                Fierté retrouvée
              </h3>
              <p className="text-sm md:text-base" data-id="element-128">
                Cette petite phrase : "J'ai géré."
              </p>
            </div>
          </div>

          <div className="max-w-3xl mx-auto bg-[#FAEBD7] text-[#2C1810] p-6 md:p-10 rounded-2xl shadow-2xl transform rotate-1" data-id="element-129">
            <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4" data-id="element-130">
              AirFryer Facile, c'est comme…
            </h3>
            <div className="flex flex-wrap justify-center gap-2 md:gap-3 text-sm md:text-base font-medium" data-id="element-131">
              <span className="bg-white px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-sm" data-id="element-132">
                🧠 Un cerveau externe
              </span>
              <span className="bg-white px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-sm" data-id="element-133">
                🧭 Un GPS culinaire
              </span>
              <span className="bg-white px-3 py-1.5 md:px-4 md:py-2 rounded-full shadow-sm" data-id="element-134">
                🛟 Une bouée de sauvetage
              </span>
            </div>
            <p className="mt-4 md:mt-5 text-lg md:text-xl italic" data-id="element-135">
              "Tu ne réfléchis plus. Tu exécutes."
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section - MOVED BEFORE TESTIMONIALS */}
      <section id="cta-section" className="py-12 md:py-16 bg-[#FFF8DC]" data-id="element-136">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
          <div className="max-w-4xl mx-auto text-center space-y-5 md:space-y-6" data-id="element-138">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810]" data-id="element-139">
              Si tu te reconnais ici…
            </h2>
            <p className="text-lg md:text-xl text-[#5D4037] max-w-2xl mx-auto leading-snug" data-id="element-140">
              Si tu en as marre de décider. Si tu veux manger sain sans y
              penser. Si tu veux arrêter de porter le dîner toute seule.
            </p>

            <div className="bg-white p-6 md:p-10 rounded-3xl shadow-2xl border-2 border-[#FF8C42] mt-8" data-id="element-141">
              <h3 className="text-2xl md:text-3xl font-bold text-[#2C1810] mb-6" data-id="element-142">
                AirFryer Facile est fait pour toi.
              </h3>

              {/* Pricing */}
              <div className="mb-6 md:mb-8" data-id="element-143">
                <div className="flex items-center justify-center gap-3 mb-2" data-id="element-144">
                  <span className="text-2xl md:text-3xl text-gray-400 line-through font-medium" data-id="element-145">
                    €13,99
                  </span>
                  <span className="text-4xl md:text-5xl font-bold text-[#D2691E]" data-id="element-146">
                    €6,99
                  </span>
                </div>
                <div className="inline-block bg-[#4CAF50] text-white px-4 py-1.5 rounded-full text-sm md:text-base font-bold" data-id="element-147">
                  -50% SOLDES D'HIVER
                </div>
              </div>

              <div className="space-y-2.5 md:space-y-3 mb-6 md:mb-8 text-left max-w-lg mx-auto" data-id="element-148">
                <div className="flex items-center gap-2.5" data-id="element-149">
                  <Check className="w-5 h-5 text-[#FF8C42] flex-shrink-0" data-id="element-150" />
                  <span className="text-base md:text-lg text-[#5D4037]" data-id="element-151">
                    Découvre le guide qui décide à ta place
                  </span>
                </div>
                <div className="flex items-center gap-2.5" data-id="element-152">
                  <Check className="w-5 h-5 text-[#FF8C42] flex-shrink-0" data-id="element-153" />
                  <span className="text-base md:text-lg text-[#5D4037]" data-id="element-154">
                    Accède à ton plan B permanent
                  </span>
                </div>
                <div className="flex items-center gap-2.5" data-id="element-155">
                  <Check className="w-5 h-5 text-[#FF8C42] flex-shrink-0" data-id="element-156" />
                  <span className="text-base md:text-lg text-[#5D4037]" data-id="element-157">
                    Libère-toi de la charge mentale dès ce soir
                  </span>
                </div>
              </div>

              <button onClick={handlePurchaseClick} className="w-full md:w-auto bg-[#FF8C42] hover:bg-[#E67A35] text-white text-lg md:text-xl font-bold py-4 px-8 md:py-5 md:px-12 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2 md:gap-3 mx-auto" data-id="element-158">
                Obtenir AirFryer Facile maintenant
                <ChevronRight className="w-6 h-6 md:w-7 md:h-7" data-id="element-159" />
              </button>

              <p className="mt-4 md:mt-5 text-[#8B4513] text-xs md:text-sm font-medium" data-id="element-160">
                Clique maintenant et transforme ta AirFryer en alliée du
                quotidien.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof / Testimonials - NOW AFTER CTA */}
      <section className="py-12 md:py-16 bg-white" data-id="element-161">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
          <div className="text-center mb-10 md:mb-12" data-id="element-163">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#2C1810] mb-3" data-id="element-164">
              Elles l'utilisent déjà
            </h2>
            <p className="text-lg md:text-xl text-[#D2691E] font-semibold" data-id="element-165">
              (et respirent enfin le soir)
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-7xl mx-auto mb-10" data-id="element-166">
            {[{
            text: "Je n'avais jamais réalisé que le problème, ce n'était pas la cuisine… mais décider. AirFryer Facile m'a littéralement enlevé un poids de la tête.",
            author: 'Sophie L.',
            location: 'Lyon',
            detail: 'maman de 2 enfants'
          }, {
            text: "À 18h, mon cerveau était KO. Maintenant, j'ouvre le guide, je choisis, j'appuie sur un bouton. C'est tout. C'est devenu mon réflexe.",
            author: 'Camille R.',
            location: 'Nantes',
            detail: 'cadre + maman'
          }, {
            text: "J'avais une AirFryer depuis 1 an… elle ne servait presque jamais. Aujourd'hui, je l'utilise 4 à 5 fois par semaine. Rentabilisée à 100%.",
            author: 'Julie M.',
            location: 'Bordeaux',
            detail: ''
          }, {
            text: "Ce que j'aime, c'est que je n'ai pas besoin de lire ou de réfléchir. Même quand je suis épuisée, ça marche. Et mes enfants adorent.",
            author: 'Élodie P.',
            location: 'Lille',
            detail: 'maman solo'
          }, {
            text: "Enfin un 'livre' que je n'ai pas besoin de finir. J'ouvre une page, je fais la recette, dîner réglé. Simple et efficace.",
            author: 'Claire D.',
            location: 'Paris',
            detail: ''
          }, {
            text: "Avant, le dîner me stressait tous les soirs. Maintenant, c'est fluide. Moins de disputes, moins de fatigue, plus de sérénité.",
            author: 'Marion T.',
            location: 'Strasbourg',
            detail: ''
          }].map((testimonial, idx) => <div key={idx} className="bg-[#FFF8DC] p-6 rounded-2xl shadow-lg border border-[#FAEBD7] relative" data-id="element-167">
                <Quote className="absolute top-4 right-4 w-8 h-8 text-[#D2691E] opacity-20" data-id="element-168" />

                {/* Stars */}
                <div className="flex gap-0.5 mb-3" data-id="element-169">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#FF8C42] text-[#FF8C42]" data-id="element-170" />)}
                </div>

                {/* Testimonial Text */}
                <p className="text-[#5D4037] text-sm md:text-base leading-relaxed mb-4 italic" data-id="element-171">
                  "{testimonial.text}"
                </p>

                {/* Author Info WITHOUT Image */}
                <div className="pt-3 border-t border-[#FAEBD7]" data-id="element-172">
                  <p className="font-bold text-[#2C1810] text-sm" data-id="element-173">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-[#8B4513]" data-id="element-174">
                    {testimonial.detail && `${testimonial.detail} – `}
                    {testimonial.location}
                  </p>
                </div>
              </div>)}
          </div>

          {/* CTA Button after testimonials */}
          <div className="text-center" data-id="element-175">
            <button onClick={scrollToCTA} className="bg-[#FF8C42] hover:bg-[#E67A35] text-white text-lg md:text-xl font-bold py-4 px-10 md:py-5 md:px-14 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 inline-flex items-center justify-center gap-3" data-id="element-176">
              Je veux le même résultat
              <ChevronRight className="w-6 h-6" data-id="element-177" />
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#2C1810] text-[#FAEBD7] py-8 border-t border-[#5D4037]" data-id="element-178">
        <div className="container mx-auto px-4 text-center" data-id="element-179">
          <p className="opacity-60 text-xs md:text-sm" data-id="element-180">
            © {new Date().getFullYear()} AirFryer Facile. Tous droits réservés.
          </p>
          <p className="mt-1.5 opacity-40 text-xs" data-id="element-181">
            Ce site ne fait pas partie du site web Facebook ou de Facebook Inc.
          </p>
        </div>
      </footer>
    </div>;
}